import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  large: {
    fontSize: 30
  }
}))
